var _excluded = ["encryptedKey"],
  _excluded2 = ["encryptedKey"];
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import { wrap as aesKw } from '../runtime/aeskw.js';
import * as ECDH from '../runtime/ecdhes.js';
import { encrypt as pbes2Kw } from '../runtime/pbes2kw.js';
import { encrypt as rsaEs } from '../runtime/rsaes.js';
import { encode as base64url } from '../runtime/base64url.js';
import normalize from '../runtime/normalize_key.js';
import generateCek, { bitLength as cekLength } from '../lib/cek.js';
import { JOSENotSupported } from '../util/errors.js';
import { exportJWK } from '../key/export.js';
import checkKeyType from './check_key_type.js';
import { wrap as aesGcmKw } from './aesgcmkw.js';
function encryptKeyManagement(_x, _x2, _x3, _x4) {
  return _encryptKeyManagement.apply(this, arguments);
}
function _encryptKeyManagement() {
  _encryptKeyManagement = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(alg, enc, key, providedCek) {
    var _normalize$normalizeP;
    var providedParameters,
      encryptedKey,
      parameters,
      cek,
      apu,
      apv,
      ephemeralKey,
      _yield$exportJWK,
      x,
      y,
      crv,
      kty,
      sharedSecret,
      kwAlg,
      p2c,
      p2s,
      _yield$pbes2Kw,
      iv,
      _yield$aesGcmKw,
      _args = arguments,
      _t,
      _t2,
      _t3;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          providedParameters = _args.length > 4 && _args[4] !== undefined ? _args[4] : {};
          checkKeyType(alg, key, 'encrypt');
          _context.n = 1;
          return (_normalize$normalizeP = normalize.normalizePublicKey) === null || _normalize$normalizeP === void 0 ? void 0 : _normalize$normalizeP.call(normalize, key, alg);
        case 1:
          _t = _context.v;
          if (_t) {
            _context.n = 2;
            break;
          }
          _t = key;
        case 2:
          key = _t;
          _t2 = alg;
          _context.n = _t2 === 'dir' ? 3 : _t2 === 'ECDH-ES' ? 4 : _t2 === 'ECDH-ES+A128KW' ? 4 : _t2 === 'ECDH-ES+A192KW' ? 4 : _t2 === 'ECDH-ES+A256KW' ? 4 : _t2 === 'RSA1_5' ? 12 : _t2 === 'RSA-OAEP' ? 12 : _t2 === 'RSA-OAEP-256' ? 12 : _t2 === 'RSA-OAEP-384' ? 12 : _t2 === 'RSA-OAEP-512' ? 12 : _t2 === 'PBES2-HS256+A128KW' ? 14 : _t2 === 'PBES2-HS384+A192KW' ? 14 : _t2 === 'PBES2-HS512+A256KW' ? 14 : _t2 === 'A128KW' ? 16 : _t2 === 'A192KW' ? 16 : _t2 === 'A256KW' ? 16 : _t2 === 'A128GCMKW' ? 18 : _t2 === 'A192GCMKW' ? 18 : _t2 === 'A256GCMKW' ? 18 : 20;
          break;
        case 3:
          cek = key;
          return _context.a(3, 21);
        case 4:
          if (ECDH.ecdhAllowed(key)) {
            _context.n = 5;
            break;
          }
          throw new JOSENotSupported('ECDH with the provided key is not allowed or not supported by your javascript runtime');
        case 5:
          apu = providedParameters.apu, apv = providedParameters.apv;
          ephemeralKey = providedParameters.epk;
          _t3 = ephemeralKey;
          if (_t3) {
            _context.n = 7;
            break;
          }
          _context.n = 6;
          return ECDH.generateEpk(key);
        case 6:
          ephemeralKey = _context.v.privateKey;
        case 7:
          _context.n = 8;
          return exportJWK(ephemeralKey);
        case 8:
          _yield$exportJWK = _context.v;
          x = _yield$exportJWK.x;
          y = _yield$exportJWK.y;
          crv = _yield$exportJWK.crv;
          kty = _yield$exportJWK.kty;
          _context.n = 9;
          return ECDH.deriveKey(key, ephemeralKey, alg === 'ECDH-ES' ? enc : alg, alg === 'ECDH-ES' ? cekLength(enc) : parseInt(alg.slice(-5, -2), 10), apu, apv);
        case 9:
          sharedSecret = _context.v;
          parameters = {
            epk: {
              x: x,
              crv: crv,
              kty: kty
            }
          };
          if (kty === 'EC') parameters.epk.y = y;
          if (apu) parameters.apu = base64url(apu);
          if (apv) parameters.apv = base64url(apv);
          if (!(alg === 'ECDH-ES')) {
            _context.n = 10;
            break;
          }
          cek = sharedSecret;
          return _context.a(3, 21);
        case 10:
          cek = providedCek || generateCek(enc);
          kwAlg = alg.slice(-6);
          _context.n = 11;
          return aesKw(kwAlg, sharedSecret, cek);
        case 11:
          encryptedKey = _context.v;
          return _context.a(3, 21);
        case 12:
          cek = providedCek || generateCek(enc);
          _context.n = 13;
          return rsaEs(alg, key, cek);
        case 13:
          encryptedKey = _context.v;
          return _context.a(3, 21);
        case 14:
          cek = providedCek || generateCek(enc);
          p2c = providedParameters.p2c, p2s = providedParameters.p2s;
          _context.n = 15;
          return pbes2Kw(alg, key, cek, p2c, p2s);
        case 15:
          _yield$pbes2Kw = _context.v;
          encryptedKey = _yield$pbes2Kw.encryptedKey;
          parameters = _objectWithoutProperties(_yield$pbes2Kw, _excluded);
          return _context.a(3, 21);
        case 16:
          cek = providedCek || generateCek(enc);
          _context.n = 17;
          return aesKw(alg, key, cek);
        case 17:
          encryptedKey = _context.v;
          return _context.a(3, 21);
        case 18:
          cek = providedCek || generateCek(enc);
          iv = providedParameters.iv;
          _context.n = 19;
          return aesGcmKw(alg, key, cek, iv);
        case 19:
          _yield$aesGcmKw = _context.v;
          encryptedKey = _yield$aesGcmKw.encryptedKey;
          parameters = _objectWithoutProperties(_yield$aesGcmKw, _excluded2);
          return _context.a(3, 21);
        case 20:
          throw new JOSENotSupported('Invalid or unsupported "alg" (JWE Algorithm) header value');
        case 21:
          return _context.a(2, {
            cek: cek,
            encryptedKey: encryptedKey,
            parameters: parameters
          });
      }
    }, _callee);
  }));
  return _encryptKeyManagement.apply(this, arguments);
}
export default encryptKeyManagement;